/*
 * anime.js v3.2.2
 * (c) 2023 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */

/*
 * BW-4483: Rebrand Animation Support
 * For more animation effect https://animejs.com/documentation/
 */
window.anime = require('animejs/lib/anime');
